import React from "react";
import { OnboardingStatus } from "../types/seeker";

type Props = {
    status: OnboardingStatus;
};

export default function OnboardingStatusBadge({ status }: Props) {
    const config = getStatusConfig(status);
    
    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "4px 8px",
                borderRadius: 12,
                fontSize: 11,
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                background: config.background,
                color: config.color,
            }}
        >
            {config.label}
        </span>
    );
}

function getStatusConfig(status: OnboardingStatus) {
    switch (status) {
        // GCS-214: package lifecycle (green shades, rising saturation)
        case "package_complete":
            return { label: "Package Complete", background: "#bbf7d0", color: "#14532d" };
        case "package_delivered":
            return { label: "Package Delivered", background: "#d1fae5", color: "#065f46" };
        case "package_purchased":
            return { label: "Package Purchased", background: "#ccfbf1", color: "#115e59" };
        case "awaiting_package":
            return { label: "Awaiting Package", background: "#fef3c7", color: "#854d0e" };
        // GCS-214: consultation outcomes
        case "consultation_completed":
            return { label: "Consult Complete", background: "#e0e7ff", color: "#3730a3" };
        case "consultation_missed":
            return { label: "Consult Missed", background: "#fee2e2", color: "#991b1b" };

        case "consultation_scheduled":
            return { label: "Consult Scheduled", background: "#ede9fe", color: "#5b21b6" };
        case "completed":
            return { label: "Complete", background: "#dcfce7", color: "#166534" };
        case "experience_preferences_completed":
            return { label: "Experience", background: "#dbeafe", color: "#1e40af" };
        case "basic_info_completed":
            return { label: "Basic Info", background: "#fef3c7", color: "#92400e" };
        case "in_progress":
            return { label: "In Progress", background: "#f3f4f6", color: "#374151" };
        default:
            return { label: "Unknown", background: "#fecaca", color: "#991b1b" };
    }
}